var _path, _rect, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackagingPlantBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9987 1.75C11.3696 1.7531 8.84927 2.79629 6.98997 4.65091C5.13068 6.50553 4.08516 9.01966 4.08203 11.6427C4.08203 19.8616 12.5941 27.4168 13.9988 27.4168C15.4034 27.4168 23.9155 19.861 23.9155 11.6427C23.9124 9.0199 22.8667 6.50571 21.0076 4.65091C19.1484 2.79611 16.6282 1.75312 13.9988 1.75H13.9987ZM13.9987 7.09727C15.136 7.09727 16.2268 7.54797 17.0308 8.3503C17.8351 9.15239 18.2869 10.2405 18.2869 11.3751C18.2869 12.5097 17.8351 13.5978 17.0308 14.3999C16.2268 15.2022 15.136 15.6529 13.9987 15.6529C12.8614 15.6529 11.7706 15.2022 10.9666 14.3999C10.1623 13.5978 9.71052 12.5097 9.71052 11.3751C9.71219 10.2409 10.1645 9.1538 10.9682 8.35195C11.772 7.55011 12.8618 7.09892 13.9987 7.09727Z",
    fill: "#1F36C7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.16602,
    y: 7,
    width: 11.6667,
    height: 9.91673,
    fill: "#1F36C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0474 10.7307L13.9124 6.99618C13.8324 6.93782 13.736 6.90625 13.637 6.90625C13.538 6.90625 13.4415 6.93782 13.3616 6.99618L8.22657 10.7307C8.10591 10.8189 8.03474 10.9594 8.03516 11.1089V17.6443C8.03516 17.7681 8.08434 17.8869 8.17187 17.9744C8.2594 18.062 8.37819 18.1112 8.50198 18.1112H9.90243V13.9098C9.90243 13.786 9.95162 13.6672 10.0391 13.5797C10.1267 13.4921 10.2455 13.443 10.3693 13.443H16.9047C17.0285 13.443 17.1473 13.4921 17.2348 13.5797C17.3223 13.6672 17.3715 13.786 17.3715 13.9098V18.1112H18.772C18.8958 18.1112 19.0146 18.062 19.1021 17.9744C19.1896 17.8869 19.2388 17.7681 19.2388 17.6443V11.1089C19.2392 10.9594 19.168 10.8189 19.0474 10.7307ZM14.5707 11.5757H12.7034C12.5366 11.5757 12.3825 11.4867 12.2992 11.3423C12.2158 11.1979 12.2158 11.0199 12.2992 10.8755C12.3825 10.731 12.5366 10.6421 12.7034 10.6421H14.5707C14.7375 10.6421 14.8916 10.731 14.975 10.8755C15.0584 11.0199 15.0584 11.1979 14.975 11.3423C14.8916 11.4867 14.7375 11.5757 14.5707 11.5757Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8359 14.377H16.4378V15.7774H10.8359V14.377Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8359 16.7109H16.4378V18.1114H10.8359V16.7109Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackagingPlantBlue);
export default __webpack_public_path__ + "static/media/packaging-plant-blue.71c13c152bdd1cf17637c3dc5fe3ce59.svg";
export { ForwardRef as ReactComponent };